import { ConfigProvider, Tabs } from "antd"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren & {
  tabs: { key: string, label: string }[]
  selectedTab: string
  onTabChange: (tab: string) => void
}

const SettingsTabs = ({ selectedTab, onTabChange, tabs, children }: Props) => {
  return <div>
    <div style={{ padding: '0 20px' }}>
      <ConfigProvider theme={{
        components: {
          Tabs: {
            margin: 0
          }
        }
      }}>
        <Tabs
          activeKey={selectedTab}
          onChange={(key) => onTabChange(key)}
          items={tabs}
        />
      </ConfigProvider>
    </div>
    <div style={{ backgroundColor: '#F0F4F8', padding: '20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {children}
      </div>
    </div>
  </div>
}

export default SettingsTabs